import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { getEnvVar } from '@mc/client-env'
import { ExperienceProvider } from '@mc/experience'
import { I18nextProvider } from '@mc/i18n'
import { SprigProvider } from '@mc/sprig'
import { useStaticData } from '@mc/static-data-react'
import { getAnonymousId } from '@mc/track-event'
import i18nInstance from 'pages/certificates/i18n/i18nInstance'
import { TrackingAttributes } from 'pages/certificates/tracking'
import { SegmentTrackingProvider } from 'pages/certificates/tracking/SegmentTrackingProvider'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

export const BaseProviders = ({ children }: { children: React.ReactNode }) => {
  const sprigConfig = {
    environmentId: getEnvVar('SPRIG_KEY') as string,
    enableLogging: getEnvVar('LOG_SURVEY_CALLS') as boolean,
    logPrefix: 'certificates',
  }

  const anonymousId = getAnonymousId()
  const { isLoggedIn } = useStaticData<{ isLoggedIn: boolean }>()

  return (
    <SegmentTrackingProvider>
      <I18nextProvider i18n={i18nInstance}>
        <SprigProvider
          config={sprigConfig}
          autoIdentify={{
            anonymousId: anonymousId ?? undefined,
            attributes: { isLoggedIn },
          }}
        >
          <TrackingAttributes product='certificates'>
            <QueryClientProvider client={queryClient}>
              <ExperienceProvider>{children}</ExperienceProvider>
            </QueryClientProvider>
          </TrackingAttributes>
        </SprigProvider>
      </I18nextProvider>
    </SegmentTrackingProvider>
  )
}
